import type { ComponentPropsWithoutRef, ElementRef } from 'react'
import { forwardRef } from 'react'

import * as ToggleGroupPrimitives from '@radix-ui/react-toggle-group'

import { classNames } from '@/utils/helpers'

export const ToggleGroup = forwardRef<
  ElementRef<typeof ToggleGroupPrimitives.Root>,
  ComponentPropsWithoutRef<typeof ToggleGroupPrimitives.Root>
>(({ className, ...props }, ref) => {
  return (
    <ToggleGroupPrimitives.Root
      className={classNames('group flex gap-2', className)}
      ref={ref}
      {...props}
    />
  )
})
ToggleGroup.displayName = 'ToggleGroup'

export const ToggleGroupItem = forwardRef<
  ElementRef<typeof ToggleGroupPrimitives.Item>,
  ComponentPropsWithoutRef<typeof ToggleGroupPrimitives.Item>
>(({ className, ...props }, ref) => (
  <ToggleGroupPrimitives.Item
    className={classNames(
      'overflow-hidden rounded-md border border-transparent py-2 text-sm font-semibold aria-checked:border-primary-500 aria-checked:bg-primary-50 dark:aria-checked:bg-secondary-800 dark:aria-checked:hover:border-primary-500',
      className,
    )}
    ref={ref}
    {...props}
  />
))
ToggleGroupItem.displayName = 'ToggleGroupItem'
